import concilia from './brands/concilia'
import nexpos from './brands/nexpos'

const brands = {
  concilia,
  nexpos
}

const HOSTNAME_RULES = [
  { pattern: /(^|[.-])nexpos([-.]|$)/i, key: 'nexpos' },
  { pattern: /(^|[.-])concilia(pos)?([-.]|$)/i, key: 'concilia' }
]

// O bundle é único - a marca é resolvida em runtime pela URL de acesso.
// REACT_APP_BRAND existe apenas como override para desenvolvimento local.
const detectFromHostname = () => {
  if (typeof window === 'undefined' || !window.location) return null
  const host = (window.location.hostname || '').toLowerCase()
  for (const rule of HOSTNAME_RULES) {
    if (rule.pattern.test(host)) return rule.key
  }
  return null
}

const envBrand = (process.env.REACT_APP_BRAND || '').toLowerCase()
const requested = envBrand || detectFromHostname() || 'concilia'
const brand = brands[requested] || brands.concilia

// Resolve baseURL do axios pela brand detectada em runtime.
// Ordem: REACT_APP_API_URL (override dev local) → brand.apiUrls[env] → fallback stag.
export const resolveApiUrl = () => {
  const override = process.env.REACT_APP_API_URL
  if (override) return override

  const env = (process.env.REACT_APP_ENV || 'STAG').toLowerCase()
  const fromBrand = brand.apiUrls && brand.apiUrls[env]
  if (fromBrand) return fromBrand

  const fallback = brand.apiUrls && brand.apiUrls.stag
  // eslint-disable-next-line no-console
  console.warn(
    `[brand] resolveApiUrl: env "${env}" não mapeado para ${brand.key}; usando fallback stag.`
  )
  return fallback
}

export default brand
